export const ActionTypes = {
  FETCH_ERP_JOB_IMPORT_LOGS_OPERATION: 'services/erpEquipmentMappingOperation/fetch_erp_job_import_logs_operation',
  SET_ERP_JOB_IMPORT_LOGS_OPERATION: 'services/erpEquipmentMappingOperation/set_erp_job_import_logs_operation',
  SET_ERP_JOB_IMPORT_LOGS_OPERATION_LOADER_STATUS:
    'services/erpEquipmentMappingOperation/set_erp_job_import_logs_operation_loader_status',
};

const fetchERPJobImportLogsOperations = ({ erpJobImportLogsOperationsParams }) => ({
  erpJobImportLogsOperationsParams,
  type: ActionTypes.FETCH_ERP_JOB_IMPORT_LOGS_OPERATION,
});

const setERPJobImportLogsOperations = ({ erpJobImportLogsOperationsData }) => ({
  erpJobImportLogsOperationsData,
  type: ActionTypes.SET_ERP_JOB_IMPORT_LOGS_OPERATION,
});

const setERPJobImportLogsOperationsLoaderStatus = ({ erpJobImportLogsOperationsLoaderStatus }) => ({
  erpJobImportLogsOperationsLoaderStatus,
  type: ActionTypes.SET_ERP_JOB_IMPORT_LOGS_OPERATION_LOADER_STATUS,
});

export default {
  fetchERPJobImportLogsOperations,
  setERPJobImportLogsOperations,
  setERPJobImportLogsOperationsLoaderStatus,
};
